import BlogListBlockProps from "./BlogListProps.interface";
import Card from "./components/Card/Card";
import CardProps from "./components/Card/CardProps.interface";
import fetchBlogPosts from "./hooks/fetchBlogPosts";
import styles from "./BlogList.module.scss";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import Masonry from "react-masonry-css";
import React, { FunctionComponent } from "react";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useAnchor from "blocks/hooks/useAnchor";
import useBoxWrap from "blocks/hooks/useBoxWrap";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const BlogList: FunctionComponent<BlogListBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);
    const { items, viewState } = fetchBlogPosts(props.content.tags);

    const breakpointColumnsObj = { default: 3, 900: 2, 500: 1 };
    const [boxWrapClasses] = useBoxWrap(props.settings.cardBoxWrap);

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses, ...boxWrapClasses)} style={{...wrapperStyles, ...splitStyles}} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses, inViewClasses)} ref={inViewElementRef}>
                {/* Loading */}
                {viewState === "LOADING" ? (
                    <div className={styles.loading}></div>
                ) : null}

                {/* Loaded */}
                {viewState === "LOADED" ? (
                    <Masonry breakpointCols={breakpointColumnsObj} className={styles.list}>
                        {items && items.map((item: CardProps, index: number) => {
                            return (
                                <Card key={index} {...item} boxWrap={props.settings.cardBoxWrap} />
                            );
                        })}
                    </Masonry>
                ) : null}

                {/* Empty */}
                {viewState === "EMPTY" ? (
                    <div>Empty</div>
                ) : null}

                {/* Error */}
                {viewState === "ERROR" ? (
                    <div>Error</div>
                ) : null}
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default BlogList;